<template>
       <!-----------Dialog ลบการบันทึก --------------->
        <v-dialog v-model="$store.state.DeleteAppointment" width="483">
      <v-card>
        <v-card-title class="d-flex justify-end">
          <v-avatar size="12px">
             <img
                  width="60"
                  height="60"
                  src="@/assets/icon/x.png"
                  alt="x"
                 @click="$store.state.DeleteAppointment = false"
                >
          </v-avatar>
        </v-card-title>
          <v-card-text class="text-center">
          <v-avatar v-if="dataOn.type==='delete'" size="146.25px">
            <img
              alt="Avatar"
              :src="require('@/assets/icon/weather_R.png')"
            />
          </v-avatar>
           <v-avatar v-else-if="dataOn.type==='success'" size="146.25px" class="mb-3">
            <img
              alt="Avatar"
              :src="require('@/assets/icon/Succes_B.png')"
            />
          </v-avatar>
          <h2 style="color: #238EF2;">{{dataOn.title}}</h2>
           <p class="font-15 color-190707">{{dataOn.text}}</p>
        </v-card-text>

        <v-card-actions class="d-flex justify-center">
          <v-btn
            outlined
            color="primary"
            @click="$store.state.DeleteAppointment = false"
            style="background: #fff; color: #5f676b"
          >
            ทำรายการต่อ
          </v-btn>
            <v-btn
            @click="DeleteResponse(),$store.state.DeleteAppointment = false"
            style="background: #238EF2; color: #fff"
          >
            ยืนยัน
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
</template>

<script>
export default {
  data: () => ({
  }),
  props: ['dataOn' ]
}
</script>

<style></style>